module.exports = require("./ln.d.ts");